import './utils/custom-history-listener';
import 'ts-replace-all';
import('./utils/telemetry').catch(console.error);

// polyfill for requestIdleCallback for safari which is 7 years behind spec (as of 2024)
import 'requestidlecallback';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import store from './store/main';
import { Provider } from 'react-redux';
import { ModalProvider } from 'react-modal-hook';


const rootElement = document.getElementById('root');
if (rootElement) {
	const root = createRoot(rootElement);
	root.render(
		<React.StrictMode>
			<Provider store={store}>
				<ModalProvider>
					<App />
				</ModalProvider>
			</Provider>
		</React.StrictMode>
	);
}
